<template>
	<v-btn
		ref="card"
		class="agent-card pa-0 d-block"
		:to="'/agent/' + agent.id"
		:title="agentName"
	>
		<section class="content">
			<z-img
				:storage="agent.avatar_url || `https://api.tb.co.th/api/getImageAgent?id=${agent.avatar}`"
				:height="maxHeight"
				width="100%"
			/>
			<div class="agentName px-3 py-2">
				<div class="red--text">
					รหัสตัวแทน
					<b style="font-size: 1.3rem;">
						{{ agent.id }}
					</b>
				</div>
				<div
					v-if="!agent.website_display_type || ['default', 'main'].includes(agent.website_display_type)"
					:title="agentName"
				>
					{{ agentName }}
				</div>
				<div
					v-if="!agent.website_display_type || ['default', 'joint'].includes(agent.website_display_type)"
					:title="agentJointName"
				>
					{{ agentJointName }}
				</div>
			</div>
			<div class="agentLocation pb-3">
				<v-icon color="#c20000">
					mdi-map-marker
				</v-icon>
				{{ agentLocation }}
			</div>
		</section>
		<div class="footer-content d-flex justify-center align py-3">
			<v-icon color="#c20000">
				mdi-file-document
			</v-icon>
			ข้อมูลตัวแทน
		</div>
	</v-btn>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	props: {
		agent: {
			type: Object,
			default: () => ({})
		}
	},

	data:() => ({
		maxHeight: '75%'
	}),

	computed: {
		...mapGetters({
			location: 'location'
		}),

		agentName () {
			let text = (this.agent.name || '')
			text += ' ' + (this.agent.surname || '')
			if (this.agent.nick_name) {
				text += ` (${this.agent.nick_name})`
			}

			return text
		},

		agentJointName () {
			if (!this.agent.is_joint) {
				return ''
			}

			let text = (this.agent.name_first_joint || '')
			text += ' ' + (this.agent.name_last_joint || '')
			if (this.agent.nick_name_joint) {
				text += ` (${this.agent.nick_name_joint})`
			}

			return text
		},

		agentLocation () {
			let text = ''
			let province = this.location.find(p => p.p === this.agent.work_area_province_id)
			if (province) {
				let district = province.v.find(d => d.d === this.agent.work_area_district_id)
				text = province.n
				text += district ? `, ${district.n}` : ''
			}

			return text
		}
	},

	methods: {
		onResize () {
			this.$nextTick(() => {
				this.maxHeight = this.$refs['card'].$el.clientWidth * 1
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.agent-card::v-deep {
	height: auto !important;
	background: none !important;
	border-radius: 0;
	box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.25);

	.v-btn__content {
		display: block;
	}
}
.content::v-deep {
	background: #fff;

	// .v-image__image.v-image__image--cover {
	// 	background-position-y: top;
	// }
	.agentName {
		box-sizing: border-box;
		min-height: 90px;
		max-height: 90px;

		div {
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	@media (max-width: 599px) {
		.agentLocation, .agentName {
			font-weight: bold;
			font-size: 1.2em;
		}
		.agentName div {
			max-width: unset;
		}
	}
}
.footer-content {
	background-color: #e9e9e9;
	font-size: 1rem;
}
</style>
